export const SEARCH_INSPECTION = 'inspection/search';
export const TRANSFER_INSPECTION = 'inspection/transfer';
